module.exports = __webpack_public_path__ + "assets/img/all_ucon.1950253c.svg";